import { ConnectorEnum, ConnectorEnumType } from './connector'
import { ConfigFieldType, Schema } from './config'

export const JobRunStatus = {
  RUNNING: 'running',
  ERROR: 'error',
  SUCCESS: 'success',
} as const

export type JobRunStatusType = (typeof JobRunStatus)[keyof typeof JobRunStatus]

export const JobStatus = {
  PENDING: 'pending',
  RUNNING: 'running',
  ERROR: 'error',
  SUCCESS: 'success',
} as const

export type JobStatusType = (typeof JobStatus)[keyof typeof JobStatus]

export const JobEnum = {
  GENERIC: 'generic',
  SQL: 'sql',
  PI: 'pi',
  SAP: 'sap',
} as const

export type JobEnumType = (typeof JobEnum)[keyof typeof JobEnum]

export const JobCompatibility: Record<JobEnumType, ConnectorEnumType[]> = {
  [JobEnum.GENERIC]: [ConnectorEnum.GENERIC, ConnectorEnum.SQL],
  [JobEnum.SQL]: [ConnectorEnum.SQL],
  [JobEnum.PI]: [ConnectorEnum.PI],
  [JobEnum.SAP]: [ConnectorEnum.SAP],
}

export const configSchema: Record<JobEnumType, Schema> = {
  [JobEnum.GENERIC]: {},
  [JobEnum.SQL]: {
    query: {
      type: ConfigFieldType.STRING,
      required: true,
    },
  },
  [JobEnum.PI]: {}, // TODO: Add PI config schema
  [JobEnum.SAP]: {}, // TODO: Add SAP config schema
}

export interface JobRecord {
  id: string
  status: JobStatusType
  type: JobEnumType
  executor_id: string
  name: string
  description: string
  created_by: string
  tenant_id: string
  config: Record<string, any>
  created_at: string
}

export interface JobRunRecord {
  id: string
  job_id: string
  status: JobRunStatusType
  started_at: string
  ended_at?: string
  result?: Record<string, any>
}

export const defaultJobRecord = (): JobRecord => ({
  id: '',
  status: JobStatus.PENDING,
  type: JobEnum.GENERIC,
  executor_id: '',
  name: '',
  description: '',
  created_by: '',
  tenant_id: '',
  config: {},
  created_at: '',
})
